import { render, staticRenderFns } from "./ProfessionalServicesSection.vue?vue&type=template&id=1e90d66c&scoped=true&"
import script from "./ProfessionalServicesSection.vue?vue&type=script&lang=js&"
export * from "./ProfessionalServicesSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalServicesSection.vue?vue&type=style&index=0&id=1e90d66c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90d66c",
  null
  
)

export default component.exports